import { EMPTY_MODULE_API_INFO, EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { EMPTY_OBJECT, connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { hideTransferModal, onTransferred } from "../actions";
import { localStateSelector, makeAccountDetailSelector, makeItemsSelector } from "../selectors";
import { type MemberWallet } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: EMPTY_MODULE_API_INFO,
  error: null,
  isVisible: false,
  status: "None",
  accounts: [],
  fieldStyle: EMPTY_OBJECT,
  defaultAccount: {
    accountId: "",
    accountNumber: "",
    balance: 0,
    closingBalance: 0,
    convertedBalance: 0,
    convertBalanceCurrencyCode: "",
    firstName: "",
    currencyCode: "",
    currencyName: "",
    isPreferred: false,
    minTransferAmount: 0,
    lastName: "",
    openingBalance: 0,
    userId: 0,
    createdOnDate: ""
  }
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const itemsSelector = makeItemsSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const detailSelector = makeAccountDetailSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.isTransferModalVisible) return INVISIBLE_PROPS;

    const accounts = itemsSelector(state, props);
    const detail = detailSelector(state, props);

    return {
      ...props,
      accounts: accounts,
      apiInfo: apiInfoSelector(state, props),
      defaultAccount: detail ?? accounts.find((x) => x.isPreferred) ?? accounts[0],
      error: localState.error,
      fieldStyle: fieldStyleSelector(state, props),
      isVisible: true,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(hideTransferModal(getEntityRef(props))),
  onSubmitted: (data: MemberWallet.Api.TransferResponse) => dispatch(onTransferred(getEntityRef(props), data.accounts))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
